///////////////////////////STAGING API'S//////////////////

// export const CASHFREEMODE = "sandbox"
// export const API_RENEWACCESSTOKEN = "https://suvarnagopura.com/MagentoAPI/api_db.js/users"
// export const API_THIRDPARTYPAYMENT = "https://suvarnagopura.com/MagentoAPI/api_db.js/api"
// export const API_THIRDPARTYPAYMENTCONFIRMATION = "https://suvarnagopura.com/MagentoAPI/api_db.js/api"
// export const API_THIRDPARTYEMIPAYMENT = "https://suvarnagopura.com/MagentoAPI/api_db.js/api"
// export const HTTP_API_RENEWACCESSTOKEN = "http://suvarnagopura.com/MagentoAPI/api_db.js/users"
// export const API_SENDOTPFORQUICKPAY ="https://jppapi.bhimagold.com/api_db.js/api/Sendotpforquickpay"
// export const API_VALIDATEOTP = "https://jppapi.bhimagold.com/api_db.js/api"
// export const API_FORGOTMSNO = "https://testapproval.bhima.info/api_db.js/api"
// export const API_PAYMENTCHECK = "https://suvarnagopura.com/MagentoAPI/api_db.js/api"
// export const SERVERDEFAULTPAGE = "http://localhost:3000"
// export const TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImJoaW1hZ29sZCIsInBhc3N3b3JkIjoiQmhpbWFAIUAjNCIsImlhdCI6MTc2NDQ4MzUwMCwiZXhwIjoxNzk2MDE5NTAwfQ.QA-Rn5wiXSPyUE25d8dkO7DSR1T2eWZLvfJNj1lZ9Ws"

//"build": "CI=false react-scripts build",
/////////////////////////PRODUCTION API'S//////////////////////////////

export const CASHFREEMODE = "production"
export const API_RENEWACCESSTOKEN = "https://bmcapis.bhimagold.com/api_db.js/users"
export const API_THIRDPARTYPAYMENT = "https://bmcapis.bhimagold.com/api_db.js/api"
export const API_THIRDPARTYPAYMENTCONFIRMATION = "https://bmcapis.bhimagold.com/api_db.js/api"
export const API_THIRDPARTYEMIPAYMENT = "https://bmcapis.bhimagold.com/api_db.js/api"
export const HTTP_API_RENEWACCESSTOKEN = "https://bmcapis.bhimagold.com/api_db.js/users"
export const API_SENDOTPFORQUICKPAY ="https://bgapis.bhimagold.com/api_db.js/api/Sendotp"
export const API_VALIDATEOTP = "https://bgapis.bhimagold.com/api_db.js/api"
export const API_FORGOTMSNO = "https://bmcapis.bhimagold.com/api_db.js/api"
export const API_PAYMENTCHECK = "https://bmcapis.bhimagold.com/api_db.js/api"
export const SERVERDEFAULTPAGE = "https://bmc.bhimagold.com"
export const TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImJoaW1hZ29sZCIsInBhc3N3b3JkIjoiQmhpbWFAIUAjNCIsImlhdCI6MTc2NDQ4MzUwMCwiZXhwIjoxNzk2MDE5NTAwfQ.QA-Rn5wiXSPyUE25d8dkO7DSR1T2eWZLvfJNj1lZ9Ws"